/*
 * @Author: Huangxianlong
 * @Date: 2023-08-11 16:44:08
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-08-15 11:47:55
 * @FilePath: \monitor\src\language\report\daily.js
 * @Description: 
 */
const info = {
  CN: {
    number: "序号",
    projectName: "项目名称",
    fileName: "文件名称",
    createTime: "创建时间",
    operation: "操作",
    downloadReport: "下载报告",

  },
  EN: {
    number: "Number",
    projectName: "Project Name",
    fileName: "File Name",
    createTime: "Create Time",
    operation: "Operations",
    downloadReport: "Download",
  }
};
export default info; //需要暴露出去



// WEBPACK FOOTER //
// ./src/language/report/daily.js